var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1D75BC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77767 9.86191C12.4174 9.86191 14.5573 7.65424 14.5573 4.93095C14.5573 2.20766 12.4174 0 9.77767 0C7.13796 0 4.99805 2.20766 4.99805 4.93095C4.99805 7.65424 7.13796 9.86191 9.77767 9.86191Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77865 19.3277C15.1792 19.3277 19.5573 17.5507 19.5573 15.3587C19.5573 13.1666 15.1792 11.3896 9.77865 11.3896C4.37805 11.3896 0 13.1666 0 15.3587C0 17.5507 4.37805 19.3277 9.77865 19.3277Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.b9aa2baa128c01f286c5d1bb3a382ff1.svg";
export { ForwardRef as ReactComponent };